import type { ReactNode } from "react";

/**
 * 하드룰이 2개 이상 걸린 본문 셀의 값(베타) — 개수 칩 + 셀 텍스트를 한 줄로 묶는다.
 * 칩은 값 앞에 인라인으로 두어 자리를 차지한다(absolute 로 띄우면 좁은 셀에서 숫자를 덮는다).
 * 백엔드가 준 셀 폭에 칩이 안 들어가면 숫자가 다음 줄로 밀리므로 줄바꿈을 막아 열 폭이 늘어나게 한다
 */
export const DsdReviewHardRuleCountChip = ({
  count,
  children,
}: {
  count: number;
  /** 셀 텍스트(renderPlainDsdCellText) */
  children: ReactNode;
}) => (
  <span className="whitespace-nowrap">
    <span
      aria-label={`하드룰 ${count}개`}
      className="mr-1.5 inline-block rounded-full bg-primary-color px-1.5 align-middle caption-2-semibold text-static-white"
    >
      {count}
    </span>
    {children}
  </span>
);
